import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteBillingPlan from 'hooks/billingPlan/useDeleteBillingPlan';
import notificationHandler from 'utils/notifications';

interface IModalBillingPlanDelete {
  opened: boolean;
  handleClose: () => void;
  billingPlanId: string;
}

const ModalBillingPlanDelete = ({
  opened,
  billingPlanId,
  handleClose,
}: IModalBillingPlanDelete): JSX.Element => {
  const deleteBillingPlan = useDeleteBillingPlan();

  const { successNotification, errorNotification } = notificationHandler();

  const handleDelete = (): void => {
    deleteBillingPlan.mutate(billingPlanId, {
      onSuccess: () => {
        handleClose();
        successNotification('Billing plan delete success', `Billing plan successfully deleted.`);
      },
      onError: error => {
        handleClose();
        errorNotification('Billing plan delete failed', error.response?.data.message);
      },
    });
  };

  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete billing plan</Title>}
      size='auto'
    >
      <Stack>
        <Text>{`Are you sure you want to delete this billing plan?`}</Text>
        <Group position='right'>
          <Button onClick={handleDelete} color='red' loading={deleteBillingPlan.isLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalBillingPlanDelete;
